import { render } from "./CreateGoogleStore.vue?vue&type=template&id=63c5fdfc"
import script from "./CreateGoogleStore.vue?vue&type=script&lang=js"
export * from "./CreateGoogleStore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__